export default [
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Suivi Instantané',
    route: 'suivi-instantane',
    icon: 'ActivityIcon',
  },
  {

    title: 'Reporting',
    icon: 'HomeIcon',
    children: [
      {
        title: 'Rapport de paiements hebdomadaire',
        route: 'reporting-weekly-payments',
      },
      {
        title: 'Suivi par Gouvernorat',
        route: 'reporting-states',
      },
      {
        title: 'Performance Fournisseur',
        route: 'reporting-supplier-performance',
      },
      {
        title: 'Statistiques Livraisons Fournisseur',
        route: 'reporting-supplier-delivery-stats',
      },
      {
        title: 'Statistiques Retours Fournisseur',
        route: 'reporting-return-voucher-stats',
      },
      {
        title: 'Top Livreurs',
        route: 'reporting-top-drivers',
      },
      {
        title: 'Chiffre affaires mensuel',
        route: 'reporting-turnover',
      },
    ],
  },
  {
    title: 'Demande partenaire',
    icon: 'UsersIcon',
    route: 'request-partner-list',
  },
  {
    title: 'Rechercher un colis',
    icon: 'SearchIcon',
    route: 'orders-search-history',
  },
  {
    title: 'Colis',
    icon: 'PackageIcon',
    children: [
      {
        title: 'Tous les colis',
        route: 'orders-index',
      },
      {
        title: 'Colis supprimé',
        route: 'orders-deleted',
        icon: 'TrashIcon',
        roles: ['admin', 'superadmin', 'admin_developer'],
      },
      {
        title: 'Réception Centre',
        route: 'order-status',
        icon: 'TargetIcon',
      },
      {
        title: 'Modification rapide des colis',
        route: 'orders-quick-edit',
        icon: 'TargetIcon',
        hideForRoles: ['superadmin'],
      },
      {
        title: 'Ajouter Extra',
        route: 'extra-fees',
        icon: 'PlusCircleIcon',
        roles: ['admin', 'superadmin', 'admin_developer', 'manager'],
      },
    ],
  },
  {
    title: 'Bordereau',
    icon: 'FileIcon',
    route: 'delivery-note-list',
  },
  {
    title: 'Pickup',
    icon: 'ShoppingCartIcon',
    route: 'pickup-list',
  },
  {
    title: 'Inventaire',
    icon: 'ArchiveIcon',
    roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    children: [
      {
        title: 'Scanner inventaire',
        route: 'inventory-dashboard',
      },
      {
        title: 'Historique inventaires',
        route: 'inventory-history',
      },
    ],
  },
  {
    title: 'Run sheet',
    icon: 'ShoppingCartIcon',
    children: [
      {
        title: 'Run sheet list',
        route: 'roadmap-list',
      },
      {
        title: 'Add run sheet',
        route: { name: 'roadmap-add' },
      },
    ],
  },
  {
    title: 'Synchronisation',
    icon: 'RefreshCwIcon',
    roles: ['admin', 'superadmin', 'admin_developer', 'manager'],
    children: [
      {
        title: 'Paramètres synchronisation',
        route: 'synchronization-list',
        icon: 'SettingsIcon',
        roles: ['admin', 'superadmin'],
      },
      {
        title: 'Désynchronisation',
        route: 'order-desynchronize-scan',
        icon: 'Link2Icon',
        roles: ['admin', 'superadmin'],
      },
      {
        title: 'Correction BL',
        route: 'sync-reference-correction',
        icon: 'Edit3Icon',
        roles: ['admin', 'superadmin', 'admin_developer'],
      },
      {
        title: 'État de synchronisation',
        route: 'sync-state-orders',
        icon: 'RefreshCwIcon',
        roles: ['admin', 'superadmin', 'manager'],
      },
      {
        title: 'Statuts non mis à jour',
        route: 'stale-outsourcing-status',
        icon: 'AlertTriangleIcon',
        roles: ['admin', 'superadmin'],
      },
      {
        title: 'Tarifs sous-traitance',
        route: 'outsourcing-pricing',
        icon: 'DollarSignIcon',
        roles: ['admin', 'superadmin'],
      },
    ],
  },
  {
    title: 'Suivi sous-traitance',
    icon: 'ClipboardIcon',
    roles: ['admin', 'superadmin', 'manager', 'outsourcing_company'],
    children: [
      {
        title: 'Liste des bons',
        route: 'manifests-list',
      },
      {
        title: 'Créer un bon',
        route: 'manifest-create',
        hideForRoles: ['outsourcing_company'],
      },
    ],
  },
  {
    title: 'Payment sous traitance',
    icon: 'DollarSignIcon',
    roles: ['admin', 'superadmin', 'manager'],
    children: [
      {
        title: 'Liste des payments',
        route: 'payment-sous-traitance-list',
      },
      {
        title: 'Créer payment',
        route: 'payment-sous-traitance-create',
      },
    ],
  },
  {
    title: 'Bon de transfert',
    icon: 'ExternalLinkIcon',
    children: [
      {
        title: 'Réception Centre',
        route: 'reception-transfert',
        icon: 'TargetIcon',
      },
      {
        title: 'Liste des bons de transfert',
        route: 'bon-transfert-list',
      },
      {
        title: 'Ajouter bon de transfert',
        route: { name: 'bon-transfert-add' },
      },
    ],
  },
  {
    title: "Manifeste d'échange",
    icon: 'RefreshCwIcon',
    roles: ['admin', 'superadmin', 'manager'],
    children: [
      {
        title: "Liste des manifestes d'échange",
        route: 'exchange-manifest-list',
      },
      {
        title: "Créer un manifeste d'échange",
        route: 'exchange-manifest-create',
      },
    ],
  },

  {
    title: "Bon d'échange",
    icon: 'CopyIcon',
    children: [
      {
        title: "Liste des bons d'échange",
        route: 'bon-echange-list',
      },
      {
        title: "Ajouter un bon d'échange",
        route: { name: 'bon-echange-add' },
      },
    ],
  },

  {

    title: 'Débrief',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Liste des débriefs',
        route: 'payment-list',
      },
      {
        title: 'Ajouter un débrief',
        route: 'payment-add',
      },
    ],
  },
  /*
  {
    title: 'Traitement anomalie',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste traitement anomalie',
        route: { name: 'bon-retour-definitive-add' },
        hideForRoles: ['manager'],
      },
      {
        title: 'Vérification Manager',
        route: { name: 'bon-retour-definitive-verify' },
        hideForRoles: ['customer_support', 'warehouse_operator'],
      },
    ],
  },
  */
  {
    title: 'Retour fournisseur',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste des bons de retour',
        route: 'bon-retour-list',
      },
      {
        title: 'Ajouter un bon de retour',
        route: { name: 'bon-retour-add' },
      },
    ],
  },
  {
    title: 'Bon A rembourser',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste des bons à rembourser',
        route: 'bon-a-rembourser-list',
      },
      {
        title: 'Ajouter un bon à rembourser',
        route: { name: 'bons-remboursement-add' },
      },
      {
        title: 'Changer le statut des bons à rembourser',
        route: { name: 'bons-a-rembourser-change-status' },
      },
    ],
  },
  {
    title: 'Retour inter-agence',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste des retours inter-agence',
        route: 'bon-retour-list-inter-agence',
      },
      {
        title: 'Ajouter un retour inter-agence',
        route: { name: 'bon-retour-inter-agence-add' },
      },
    ],
  },
  {
    title: 'Finance',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Liste des règlements',
        route: 'invoice-list',
      },
      {
        title: 'Générer règlement',
        route: { name: 'invoice-add' },
        hideForRoles: ['superadmin'],
      },
      {
        title: 'Règlement Direx',
        route: 'invoice-list-direx',
      },
    ],
  },
  {
    title: 'Dépenses',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Toutes les dépenses',
        route: 'expenses-index',
      },
      {
        title: 'Nouvelle dépense',
        route: 'expenses-create',
      },
      {
        title: 'Fournisseurs',
        route: 'vendors-index',
      },
      {
        title: 'Catégories',
        route: 'categories-index',
      },
    ],
  },
  {
    title: 'Commissions',
    icon: 'TrendingUpIcon',
    children: [
      {
        title: 'Taux de commission',
        route: 'admin-commission-rates',
      },
      {
        title: 'Attributions expéditeurs',
        route: 'admin-supplier-attributions',
      },
      {
        title: 'Factures de commission',
        route: 'admin-commission-invoices',
      },
    ],
  },
  {
    title: 'Factures Livreurs',
    icon: 'TruckIcon',
    route: 'driver-invoice-list',
  },
  {
    title: 'Utilisateurs',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Expéditeur',
        route: 'supplier-list',
      },
      {
        title: 'Livreurs',
        route: 'delivery-man-list',
      },
      {
        title: 'Ramasseurs',
        route: 'pickupeur-list',
      },
      {
        title: 'Responsables',
        route: 'manager-list',
      },
      {
        title: 'Personnel',
        route: 'staff-list',
      },
    ],
  },
  {
    title: 'Localisation',
    icon: 'MapPinIcon',
    children: [
      {
        title: 'Gouvernorats',
        route: 'governorate-list',
      },
      {
        title: 'Délégations',
        route: 'delegation-list',
      },
      {
        title: 'Localités',
        route: 'localities-list',
      },
    ],
  },
  {
    title: 'Paramètres',
    icon: 'TruckIcon',
    children: [
      {
        title: 'Bannières',
        route: 'dashboard-banner-parameters',
        icon: 'BellIcon',
        meta: { requiresAdmin: true },
      },

      {
        title: 'Frais société',
        route: { name: 'parameters', hash: '' },
        icon: 'SettingsIcon',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Run sheets',
        route: 'roadmap-print-parameters',
        icon: 'PrinterIcon',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Bordereaux fournisseur',
        route: 'supplier-bordereau-display-parameters',
        icon: 'FileTextIcon',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Note bordereaux',
        route: 'delivery-note-print-note-parameters',
        icon: 'FileTextIcon',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Inventaire',
        route: 'inventory-parameters',
        icon: 'ArchiveIcon',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Motifs de retour',
        route: 'return-reason-type-list',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Dépôts',
        route: 'repository-list',
      },
      {
        title: 'Véhicules',
        route: 'car-list',
      },
      {
        title: 'Poids volumétrique',
        route: 'weight-list',
      },
      {
        title: 'Catégories de tickets',
        route: 'ticket-category-list',
        meta: { requiresAdmin: true },
      },
    ],
  },
  {
    title: 'Support',
    icon: 'mdi-lifebuoy',
    children: [
      {
        title: 'Tickets de support',
        icon: 'HelpCircleIcon',
        route: 'SupportTicketList',
      },
      {
        title: 'Réclamations Livreur',
        icon: 'TruckIcon',
        route: 'support-driver-ticket-list',
      },
      {
        title: 'Demandes de nouvelle livraison',
        icon: 'TruckIcon',
        route: 'RedeliveryRequestList',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Demandes de modification de prix',
        icon: 'DollarSignIcon',
        route: 'PriceChangeRequestList',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Demandes de modification de profil',
        icon: 'EditIcon',
        route: 'ProfileChangeRequestList',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Demandes de désactivation',
        icon: 'UserXIcon',
        route: 'AccountDisableRequestList',
        meta: { requiresAdmin: true },
      },
    ],
  },
]
